import { ADD_PRODUTO, LIMPAR_CARRINHO, EXCLUIR_PRODUTO, ATUALIZA_QTD_PRODUTO } from './mutation-types'

export default {
    adicionarProdutoAoCarrinho({ commit, state }, { produto }){
        if(state.produtos.find(prod => prod.id == produto.id)){
            commit(ATUALIZA_QTD_PRODUTO, produto.id)
        }
        else{
            commit(ADD_PRODUTO, produto);
        }
    },
    
    limparCarrinho({ commit }) {
        commit(LIMPAR_CARRINHO)
    },
    excluirItemCarrinho({ commit }, {idProduto}){
        commit(EXCLUIR_PRODUTO,idProduto);
    }
}